// extracted by mini-css-extract-plugin
module.exports = {"backgroundGradient":"styles_backgroundGradient__M3tk7"};